import useIntersectionObserver from "@react-hook/intersection-observer";
import useScript from "lib/hooks/useScript";
import { useCallback, useEffect, useRef, useState } from "react";

const ID_VIDEO_PLAYER = "lawfullyProVideoPlayer";

export const Video = () => {
  const videoContainer = useRef<HTMLDivElement>(null);
  const playerRef = useRef(null);
  const { isIntersecting } = useIntersectionObserver(videoContainer, {
    threshold: 0.3,
  });
  const [isVideoReady, setIsVideoReady] = useState(false);

  const handleOnReady = useCallback(() => {
    // Autoplay is allowed if muted.
    playerRef.current?.mute();
    setIsVideoReady(true);
  }, []);

  const embedPlayer = useCallback(() => {
    return new (window as any).YT.Player(ID_VIDEO_PLAYER, {
      height: "542",
      width: "966",
      videoId: "JaaSEPtywUo",
      playerVars: {
        autoplay: 1,
        loop: 1,
        playsinline: 1,
        playlist: "JaaSEPtywUo",
        rel: 0,
      },
      events: {
        onReady: handleOnReady,
      },
    });
  }, [handleOnReady]);

  // Load YouTube Iframe API to embed a player.
  //   - https://developers.google.com/youtube/iframe_api_reference
  useEffect(() => {
    if ((window as any).YT?.Player) {
      // API is already ready.
      playerRef.current = embedPlayer();
    } else {
      // API is not ready. Define on-ready callback.
      (window as any).onYouTubeIframeAPIReady = () => {
        playerRef.current = embedPlayer();
      };
    }
  }, [embedPlayer]);
  useScript("https://www.youtube.com/iframe_api");

  // Play if in viewport, pause otherwise.
  useEffect(() => {
    if (isVideoReady) {
      if (isIntersecting) {
        playerRef.current?.playVideo();
      } else {
        playerRef.current?.pauseVideo();
      }
    }
  }, [isIntersecting, isVideoReady]);

  return (
    <div
      css={`
        margin: 0 auto;
        max-width: 1000px;
        text-align: center;
        ${({ theme: { breakpoints } }) => breakpoints.down("sm")} {
          marign-bottom: 140px;
        }
      `}
    >
      <div
        css={`
          margin: 0 auto;
          max-width: 966px;
        `}
        ref={videoContainer}
      >
        <div
          css={`
            position: relative;
            width: 100%;
            height: 0;
            padding-bottom: ${(542 / 966) * 100}%;
          `}
        >
          <div
            css={`
              position: absolute;
              top: 0;
              left: 0;
              right: 0;
              bottom: 0;
              border-radius: 12px;
              background-color: #f1f3f5;
              overflow: hidden;
            `}
          >
            <div
              css={`
                width: 100%;
                height: 100%;
              `}
              id={ID_VIDEO_PLAYER}
            />
          </div>
        </div>
      </div>
    </div>
  );
};
